import React from 'react'

import s from '../styles.module.scss'

const JsonViewer = ({ data }) => {
  return <div className={s.jsonViewer}>{<pre>{JSON.stringify(data, null, 2)}</pre>}</div>
}

export default JsonViewer
